import * as React from "react";
import {Component} from "react";
import {connect} from "react-redux";
import LoadingPage from "../LoadingPage";
import MailroomActiveConnectionsOverTimeCard from "./MailroomActiveConnectionsOverTimeCard";
import {MailroomAnalyticsResult} from "../../models/MailroomAnalyticsResult";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import {IRootState} from "../../store";
import {Doughnut} from "react-chartjs-2";


interface MailroomAnalyticsPageProps {
    apiService: ApiService;
}

interface MailroomAnalyticsPageState {
    mailroomAnalyticsResult?:  MailroomAnalyticsResult;
}

class MailroomAnalyticsPage extends Component<MailroomAnalyticsPageProps & DispatchProps,MailroomAnalyticsPageState> {
    
    constructor(props: MailroomAnalyticsPageProps & DispatchProps) {
        super(props);

        this.state = {
            mailroomAnalyticsResult: undefined,
        };
    }

    async componentDidMount(): Promise<void> {
        const analyticsResult = await this.props.apiService.getMailroomAnalytics();
        this.setState({
            mailroomAnalyticsResult: analyticsResult
        });
    }

    async componentDidUpdate(prevProps: Readonly<MailroomAnalyticsPageProps & DispatchProps>, prevState: any): Promise<void>
    {
    }
    
    private buildDoughnutCard(number: number,total: number,percentage: number,title: string,verb: string) : JSX.Element
    {
        var doughnutData = {
            labels: [verb,`Not ${verb}`],
            datasets: [{
                data: [number,total-number],
                backgroundColor: [
                    '#99c140',
                    '#e7b416'
                ]
            }]
        }
        
        
        return (
            <div className="card flex-item--flex-1 flex-column flex--align-items-center">
                <div className="doughnut-holder--small">
                    <Doughnut data={doughnutData} height={1} width={1} />
                </div>
                <div className="number-stat">
                    <span className="number-stat__number number-stat__number--small">{percentage.toFixed(0)}%</span>
                    <span className="number-stat__description">
                            {number} {title} {verb}
                        </span>
                </div>
            </div>
        )
    }
    
    public render(): JSX.Element {

        if(this.state.mailroomAnalyticsResult === undefined)
        {
            return (
                <LoadingPage/>
            );
        }
        
        return (
            <div>
                
                <div className={"flex-row"}>
                    {this.buildDoughnutCard(this.state.mailroomAnalyticsResult.schoolsWithActiveConnection,this.state.mailroomAnalyticsResult.numberOfPotentialMailroomSchools,this.state.mailroomAnalyticsResult.schoolsWithActiveConnectionPercentage,"Schools","Sending data to mailroom inbox")}
                    {this.buildDoughnutCard(this.state.mailroomAnalyticsResult.schoolsWithRecentAutomation,this.state.mailroomAnalyticsResult.numberOfPotentialMailroomSchools,this.state.mailroomAnalyticsResult.schoolsWithRecentAutomationPercentage,"Schools","Running in automation recently")}
                </div>

                <MailroomActiveConnectionsOverTimeCard mailroomAnalyticsResult={this.state.mailroomAnalyticsResult}/>

                
            </div>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): MailroomAnalyticsPageProps => {

        return {
            apiService: state.auth.apiService
        };

    }
)(MailroomAnalyticsPage)